export default function OnMatrixDetailPanelVisibleChanged(sender: any, options: any) {
  if (options.visible) {
    options.question.visibleRows.forEach((row: any) => {
      if (row !== options.row) {
        row.hideDetailPanel(true);
      }
    });
  }
  if (!options.visible) {
    options.row.hideDetailPanel(true);
  }
}
